export type RepertoireCategory = 'nl' | 'int' | 'feest'

export type RepertoireEntry = {
  artist: string
  songs: string[]
  category: RepertoireCategory
}

export const repertoire: RepertoireEntry[] = [
  { artist: 'André Hazes', songs: ['Bloed, zweet en tranen', 'Het is tijd', 'Kleine jongen', 'Leef (junior)'], category: 'nl' },
  { artist: 'A Star Is Born', songs: ['Shallow'], category: 'int' },
  { artist: 'Acda en de Munnik', songs: ['Regent zonnestralen', 'Ren Lenny ren'], category: 'nl' },
  { artist: 'Air', songs: ['All I need'], category: 'int' },
  { artist: 'America', songs: ['A horse with no name'], category: 'int' },
  { artist: 'Anouk', songs: ['Lost', 'Michel'], category: 'nl' },
  { artist: 'Band Aid', songs: ['Do they know it’s Christmas'], category: 'feest' },
  { artist: 'The Beatles', songs: ['Hey Jude', 'Yesterday'], category: 'int' },
  { artist: 'Bill Withers', songs: ['Lovely day'], category: 'int' },
  { artist: 'Bløf', songs: ['Aan de kust', 'Dansen aan zee', 'Liefs uit Londen', 'Mooie dag', 'Oktober', 'Zoutelande'], category: 'nl' },
  { artist: 'Bloem', songs: ['Even aan mijn moeder vragen'], category: 'nl' },
  { artist: 'Boudewijn de Groot', songs: ['Avond', 'Jimmy'], category: 'nl' },
  { artist: 'Bruce Springsteen', songs: ['Dancing in the dark', 'Secret garden', 'I’m on fire'], category: 'int' },
  { artist: 'CCR', songs: ['Have you ever seen the rain'], category: 'int' },
  { artist: 'Chef’Special', songs: ['In your arms'], category: 'int' },
  { artist: 'Chris Rea', songs: ['Driving home for Christmas'], category: 'feest' },
  { artist: 'Circus Custers', songs: ['Monica'], category: 'nl' },
  { artist: 'Claudia de Breij', songs: ['Mag ik dan bij jou'], category: 'nl' },
  { artist: 'Clouseau', songs: ['Daar gaat ze', 'Laat me nu toch niet alleen'], category: 'nl' },
  { artist: 'Cock Robin', songs: ['The promise you made'], category: 'int' },
  { artist: 'Coldplay', songs: ['The Scientist', 'Trouble'], category: 'int' },
  { artist: 'Crowded House', songs: ['Don’t dream it’s over', 'Weather with you', 'Four seasons in one day'], category: 'int' },
  { artist: 'Cyndi Lauper', songs: ['Time after time', 'True colors'], category: 'int' },
  { artist: 'Danny Vera', songs: ['Rollercoaster'], category: 'nl' },
  { artist: 'De Dijk', songs: ['Als ze er niet is', 'Groot hart'], category: 'nl' },
  { artist: 'Deep Blue Something', songs: ['Breakfast at Tiffany’s'], category: 'int' },
  { artist: 'Don McLean', songs: ['Vincent'], category: 'int' },
  { artist: 'Eagles', songs: ['Hotel California', 'Please come home for Christmas'], category: 'int' },
  { artist: 'Elton John', songs: ['Can you feel the love tonight', 'Circle of life'], category: 'int' },
  { artist: 'Elvis Presley', songs: ['Always on my mind', 'Can’t help falling in love', 'Suspicious minds'], category: 'int' },
  { artist: 'Eric Clapton', songs: ['Layla', 'Tears in heaven'], category: 'int' },
  { artist: 'Family of the Year', songs: ['Hero'], category: 'int' },
  { artist: 'Feargal Sharkey', songs: ['A good heart'], category: 'int' },
  { artist: 'Fluitsma en van Tijn', songs: ['15 miljoen mensen'], category: 'nl' },
  { artist: 'Frank Boeijen', songs: ['Kronenburg park', 'Zwart-wit'], category: 'nl' },
  { artist: 'Gary Jules', songs: ['Mad world'], category: 'int' },
  { artist: 'George Ezra', songs: ['Shotgun'], category: 'int' },
  { artist: 'Gerard Cox', songs: ['Voorbij die mooie zomer'], category: 'nl' },
  { artist: 'Guus Meeuwis', songs: ['Het is een nacht', 'Kedeng kedeng', 'Proosten', 'Zo ver weg'], category: 'nl' },
  { artist: 'Hans de Booij', songs: ['Annabel'], category: 'nl' },
  { artist: 'Herman van Veen', songs: ['Anne', 'Opzij opzij'], category: 'nl' },
  { artist: 'IOS', songs: ['Altijd wel iemand', 'Hoofd onder water', 'Stap uit de schaduw'], category: 'nl' },
  { artist: 'Jazzpolitie', songs: ['Liefdesliedjes'], category: 'nl' },
  { artist: 'John Denver', songs: ['Annie’s song', 'Take me home, country roads'], category: 'int' },
  { artist: 'John Lennon', songs: ['Imagine', 'Happy Xmas (War is over)'], category: 'int' },
  { artist: 'Johnny Cash', songs: ['Hurt'], category: 'int' },
  { artist: 'Jona Lewie', songs: ['Stop the cavalry'], category: 'feest' },
  { artist: 'Joshua Kadison', songs: ['Jessie'], category: 'int' },
  { artist: 'Klein Orkest', songs: ['Over de muur'], category: 'nl' },
  { artist: 'Leonard Cohen', songs: ['Hallelujah'], category: 'int' },
  { artist: 'Los Lobos', songs: ['La bamba'], category: 'int' },
  { artist: 'Marcel Schuitemaker', songs: ['Engelbewaarder'], category: 'nl' },
  { artist: 'Michel Fugain', songs: ['Une belle histoire'], category: 'int' },
  { artist: 'Midnight Oil', songs: ['Beds are burning'], category: 'int' },
  { artist: 'Moody Blues', songs: ['Nights in white satin'], category: 'int' },
  { artist: 'Neil Diamond', songs: ['Sweet Caroline'], category: 'int' },
  { artist: 'Neil Young', songs: ['Heart of gold'], category: 'int' },
  { artist: 'Niall Horan', songs: ['This town'], category: 'int' },
  { artist: 'Oasis', songs: ['Wonderwall'], category: 'int' },
  { artist: 'Passenger', songs: ['Let her go'], category: 'int' },
  { artist: 'Paul Young', songs: ['Love of the common people'], category: 'int' },
  { artist: 'Pearl Jam', songs: ['Just breathe'], category: 'int' },
  { artist: 'Phil Collins', songs: ['Another day in paradise', 'Jesus he knows me'], category: 'int' },
  { artist: 'Pink Floyd', songs: ['Wish you were here'], category: 'int' },
  { artist: 'Poema’s', songs: ['Zij maakt het verschil'], category: 'nl' },
  { artist: 'The Pretenders', songs: ['2000 miles'], category: 'feest' },
  { artist: 'Queen', songs: ['Crazy little thing called love'], category: 'int' },
  { artist: 'R.E.M.', songs: ['Everybody hurts', 'Losing my religion'], category: 'int' },
  { artist: 'Radiohead', songs: ['Fade out'], category: 'int' },
  { artist: 'Ramses Shaffy', songs: ['Laat me'], category: 'nl' },
  { artist: 'René Froger', songs: ['Alles kan een mens gelukkig maken'], category: 'nl' },
  { artist: 'René Klijn', songs: ['Mr. Blue'], category: 'nl' },
  { artist: 'Rob de Nijs', songs: ['Banger hart', 'Het werd zomer', 'Malle Babbe'], category: 'nl' },
  { artist: 'Robbie Williams', songs: ['Angels'], category: 'int' },
  { artist: 'Robert Long', songs: ['Flink zijn', 'Iedereen doet het'], category: 'nl' },
  { artist: 'Ronan Keating', songs: ['When you say nothing at all'], category: 'int' },
  { artist: 'Roy Orbison', songs: ['You got it'], category: 'int' },
  { artist: 'Sam Cooke', songs: ['Wonderful world'], category: 'int' },
  { artist: 'The Scène', songs: ['Blauw', 'Iedereen is van de wereld'], category: 'nl' },
  { artist: 'Simple Minds', songs: ['Don’t you (forget about me)'], category: 'int' },
  { artist: 'Spandau Ballet', songs: ['Through the barricades', 'True'], category: 'int' },
  { artist: 'Stef Bos', songs: ['Papa'], category: 'nl' },
  { artist: 'Sting', songs: ['Fields of gold'], category: 'int' },
  { artist: 'Tears for Fears', songs: ['Shout'], category: 'int' },
  { artist: 'Tom Petty', songs: ['Learning to fly'], category: 'int' },
  { artist: 'Train', songs: ['Drops of Jupiter'], category: 'int' },
  { artist: 'Traveling Wilburys', songs: ['Handle with care'], category: 'int' },
  { artist: 'U2', songs: ['One'], category: 'int' },
  { artist: 'Vader Abraham', songs: ['Kleine café aan de haven', 'Het Smurfenlied'], category: 'nl' },
  { artist: 'Van Dik Hout', songs: ['Stil in mij'], category: 'nl' },
  { artist: 'Volumia!', songs: ['Hou me vast'], category: 'nl' },
  { artist: 'Wet Wet Wet', songs: ['Love is all around'], category: 'int' },
  { artist: 'Wham!', songs: ['Last Christmas'], category: 'feest' },
  { artist: 'Wim Sonneveld', songs: ['Het dorp'], category: 'nl' },
  { artist: 'X Ambassadors', songs: ['Renegades'], category: 'int' },
  { artist: 'Feestdagen & overig', songs: ['We wish you a merry Christmas', 'Merry Christmas everyone', 'Jingle bells', 'Holly jolly Christmas', 'Winter wonderland', 'Hark, the herald angels sing', 'Sinterklaas, wie kent hem niet', 'Happy birthday', 'Scarborough fair'], category: 'feest' },
]

export const repertoireFilters: { id: 'all' | RepertoireCategory; label: string }[] = [
  { id: 'all', label: 'Alles' },
  { id: 'nl', label: 'Nederlandstalig' },
  { id: 'int', label: 'Internationaal' },
  { id: 'feest', label: 'Kerst & feest' },
]
